/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ALL_STATUS, ORDER_HISTORY_DATE_FILTER_TWO_YEARS } from '../../configuration/order-history';
import { trackedAction } from '../../utilities/track-execution-time';
import { action as getOrderHistory, GetOrderHistoryInput, IGetOrderHistoryData } from './get-order-history.action';

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput =>
    new GetOrderHistoryInput(args, ALL_STATUS, ORDER_HISTORY_DATE_FILTER_TWO_YEARS);

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetOrderHistoryData>>((input, ctx) => trackedAction(getOrderHistory, input, ctx, 'GetHistory')),
    id: 'GetReorderOrderHistory',
    input: createInput
});
